import { render, staticRenderFns } from "./AgentQa.vue?vue&type=template&id=695f1865&scoped=true"
import script from "./AgentQa.vue?vue&type=script&lang=js"
export * from "./AgentQa.vue?vue&type=script&lang=js"
import style0 from "./AgentQa.vue?vue&type=style&index=0&id=695f1865&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695f1865",
  null
  
)

export default component.exports